export default __webpack_public_path__ + "static/media/List of Resource Persons.30bc5cf2.pdf";